<template>
  <div class="case-news-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-section">
      <div class="breadcrumb">
        <span class="breadcrumb-item link" @click="goCasesIndex">造价案例</span>
        <span class="breadcrumb-separator">></span>
        <span class="breadcrumb-item link" @click="goBack">案例详情</span>
        <span class="breadcrumb-separator">></span>
        <span class="breadcrumb-item">个人简介</span>
      </div>
    </div>

    <!-- 个人简介信息 -->
    <div class="profile-section">
      <div class="profile-header">
        <div class="avatar-section">
          <img src="@/assets/image/bg1.png" alt="用户头像" class="user-avatar">
          <div class="user-info">
            <h2 class="username">小城夏天</h2>
            <div class="certifications">
              <div class="cert-item cost-engineer">
                <img src="@/assets/image/al/zjs.png" alt="造价师" class="cert-icon">
                <span>造价师认证</span>
              </div>
              <!-- <div class="cert-item visitor">
                <img src="@/assets/image/al/yk.png" alt="游客" class="cert-icon">
                <span>游客</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="profile-details">
        <div class="detail-item">
          <span class="label">专业：</span>
          <span class="value">建筑</span>
        </div>
        <div class="detail-item">
          <span class="label">从业时间：</span>
          <span class="value">2025-03-10 09:30:30</span>
        </div>
        <div class="detail-item">
          <span class="label">地区：</span>
          <span class="value">河南郑州</span>
        </div>
        <div class="detail-item">
          <span class="label">星级评价：</span>
          <div class="star-rating">
            <img src="@/assets/image/scy.png" alt="星" class="star-icon">
            <img src="@/assets/image/scy.png" alt="星" class="star-icon">
            <img src="@/assets/image/scy.png" alt="星" class="star-icon">
            <img src="@/assets/image/scn.png" alt="星" class="star-icon">
            <img src="@/assets/image/scn.png" alt="星" class="star-icon">
          </div>
        </div>
      </div>

      <div class="profile-intro">
        <p> <span style="color: #999999;">个人简介：</span> 这里是个人简介的具体内容这里是个人简介的具体内容这里是个人简介的具体内容这里是个人简介的具体内容这里是个人简介的具体内容这里是个人简介的具体内容.......</p>
      </div>
    </div>

    <!-- 我的案例 -->
    <div class="my-cases-section">
      <h3 class="section-title">我的案例</h3>
      <div class="cases-grid">
        <div
          v-for="caseItem in myCases"
          :key="caseItem.id"
          class="case-card"
          @click="viewCaseDetail(caseItem)"
        >
          <div class="case-image">
            <img
              :src="caseItem.image"
              :alt="caseItem.title"
              class="case-img"
            >
          </div>
          <div class="case-title">{{ caseItem.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CaseNews',
  data() {
    return {
      myCases: [
        {
          id: 1,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg1.png')
        },
        {
          id: 2,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg2.png')
        },
        {
          id: 3,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg3.png')
        },
        {
          id: 4,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg4.png')
        },
        {
          id: 5,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg5.png')
        },
        {
          id: 6,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg6.png')
        },
        {
          id: 7,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg1.png')
        },
        {
          id: 8,
          title: '时代广场-中心花园项目改造.......',
          image: require('@/assets/image/bg2.png')
        }
      ]
    }
  },
  methods: {
    viewCaseDetail(caseItem) {
      this.$router.push({
        path: '/costcases/caseDetail',
        query: { id: caseItem.id }
      })
    },
    goBack() {
      this.$router.back()
    },
    goCasesIndex() {
      this.$router.push('/costcases/index')
    }
  }
}
</script>

<style lang="scss" scoped>
.case-news-container {
	width: var(--page-container-ratio, 70%);
	margin: 0 auto;
  min-height: 100vh;
  background: #f5f5f5;
  padding: 20px;
}

.breadcrumb-section {
  background: #fff;
  padding: 20px 30px;
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .breadcrumb {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;

    .breadcrumb-item {
      color: #000;
      &.link { cursor: pointer; color:#0F70E2; }
    }

    .breadcrumb-separator {
      margin: 0 8px;
      color: #999;
    }
  }
}

.profile-section {
  background: #fff;
  padding: 30px;
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .profile-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 30px;

    .avatar-section {

      .user-avatar {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        margin-bottom: 20px;
        object-fit: cover;
      }

      .user-info {
        .username {
          font-size: 24px;
          font-weight: bold;
          color: #333;
          margin: 0 0 15px 0;
        }

        .certifications {
          display: flex;
          gap: 20px;

          .cert-item {
            display: flex;
            align-items: center;
            font-size: 14px;

            .cert-icon {
              width: 16px;
              height: 16px;
              margin-right: 5px;
              object-fit: contain;
            }

            &.cost-engineer {
              color: #0F70E3;
            }

            &.visitor {
              color: #475C70;
            }
          }
        }
      }
    }

    .rating-section {
      .stars {
        display: flex;
        gap: 2px;

        i {
          font-size: 20px;
          color: #ffc107;

          &.el-icon-star-off {
            color: #ddd;
          }
        }
      }
    }
  }

  .profile-details {
    margin-bottom: 30px;

    .detail-item {
      display: flex;
      margin-bottom: 15px;
      font-size: 16px;
      align-items: center;

      .label {
        font-weight: bold;
        color: #999;
        width: 100px;
      }

      .value {
        color: #111111;
      }

      .star-rating {
        display: flex;
        align-items: center;
        gap: 3px;

        .star-icon {
          width: 16px;
          height: 16px;
          object-fit: contain;
        }
      }
    }
  }

  .profile-intro {

    p {
      font-size: 16px;
      line-height: 1.6;
      color: #111;
      text-align: justify;
    }
  }
}

.my-cases-section {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .section-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
  }

  .cases-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;

    .case-card {
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
      }

      .case-image {
        margin-bottom: 10px;

        .case-img {
          width: 100%;
          height: 150px;
          object-fit: cover;
          border-radius: 6px;
        }
      }

      .case-title {
        font-size: 14px;
        color: #666;
        line-height: 1.4;
        text-align: center;
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .my-cases-section .cases-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .case-news-container {
    padding: 10px;
  }

  .profile-section,
  .my-cases-section {
    padding: 20px;
  }

  .profile-header {
    flex-direction: column;
    align-items: flex-start;

    .rating-section {
      margin-top: 20px;
    }
  }

  .my-cases-section .cases-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
}

@media (max-width: 480px) {
  .my-cases-section .cases-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}
</style>
